<template lang="html">
  <section class="landing"> 
    <table  class="col-lg-12" v-if="!showModels">
      <th :class="" v-for="(region, index) in regions" :key="region.label">
        <span class="col-lg-12 clickable" @click="showCountry(region.countryList, index)">{{region.label}}</span>
      </th>
      <tr><td><span style="min-height:6px; display:block">&nbsp;</span></td></tr>
      <tr v-if="showCountries" v-for="country in countries" :key="country.id">      
        <td v-for="i in tableIndex" :key="i"></td>
        <td class="hovered clickable" style="border:solid 1px #B6B6B6"  @click="showRange(country)"><span class="col-lg-12 ">{{country.description}}</span></td>
      </tr>
    </table>   
    <template v-else>
      <b-row>
        <span class="col-lg-3"><b-button variant="primary" @click="showModels=false"><i class="mdi mdi-arrow-left"></i>Back</b-button></span>
        <span class="col-lg-6"></span>
        <span class="col-lg-3"><b>Current country: </b>{{countrySelected.description}}</span>
      </b-row>
      <hr>
      <b-row>
        <table class="col-lg-12">
          <th :class="" v-for="(family, index) in families" :key="family.code">
            {{family.description}}
          </th>
          <tr><td><span style="min-height:6px; display:block">&nbsp;</span></td></tr>
          <tr v-for="i in maxModelsInFamily" :key="i+'family'">
            <td  class="hovered" style="border:solid 1px #B6B6B6"  v-for="(family, index) in families" :key="family.code+'inner'">
                <a  style="display: block;width:100%" v-if="i-1<family.models.length" class="col-lg-12 clickable" target="_blank" :href="getBaseUrl + family.models[i-1].urlContext + '?modelCode=' + family.models[i-1].vetele + '&currentCountry=' + countrySelected.id + '&lang=' + family.models[i-1].lang + '&version=' + family.models[i-1].version">{{family.models[i-1].modelDescription}} <br/>{{family.models[i-1].code}} <br/> {{family.models[i-1].model.vetele}}-{{family.models[i-1].model.modelYear}}</a>
            </td>
          </tr>
        </table>
      </b-row>
    </template>
  </section>
</template>
<style>
.clickable {
  cursor: pointer;
}
a {
  color: #060D1D;
}
a:hover {
  color: #060D1D;
  text-decoration: none;
}
td, th {
  text-align: center;
}
.hovered:hover{
  background-color: darkgray;

}
</style>
<script lang="js">
import { mapState, mapActions, mapGetters } from "vuex"
export default {
  name: 'landing',
  methods: {
    showCountry(countryList, index){
      this.tableIndex = index;
      this.countries = countryList;
      this.showCountries=true;
    },
    showRange(country) {
      this.setSpinnerStatus(true);
      this.showModels = true;
      this.countrySelected = country;
      this.axios
        .get('/ccb/public/fe/landing/getCountryRange/'+country.id, this.authHeader)
          .then((response) => {
            this.families = response.data;
            this.maxModelsInFamily = 0;
            this.families.forEach(family => {
              this.maxModelsInFamily = Math.max(this.maxModelsInFamily, family.models.length);
            });
          })
          .finally(() => this.setSpinnerStatus(false));
    },
    search() {
     // this.setLastSearch(this.search);
      this.setSpinnerStatus(true);
      this.axios
        .get('/ccb/public/fe/landing/getLandingGeoRegion', this.authHeader)
          .then((response) => {
            //console.log(response.data);
            this.regions = response.data;
          })
          .finally(() => this.setSpinnerStatus(false));
          
    },
    refreshTable() {
      this.search();
    },
    ...mapActions([
      'setCurApp',
      'setLastSearch',
      'setSpinnerStatus'
    ])
  },
  data () {
    return {
      showCountries: false,
      showModels: false,
      regions : [],
      countries : [],
      countrySelected:null,
      tableIndex:0,
      families: [],
      maxModelsInFamily:0
    }
  },
  computed: {
    ...mapState([
    ]),
    ...mapGetters([
      'getBaseUrl'
    ])
  },
  watch: {
  },
  created() {
  },
  mounted() {
    window.scoper = this
    this.search();
    this.setCurApp('landing');
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}
</style>
